function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { array, isArray, stringValue } from 'vega-util';
import { COLOR, OPACITY } from '../../channel';
import { hasConditionalValueDef, isFieldDef, isValueDef } from '../../channeldef';
import { FILL_STROKE_CONFIG } from '../../mark';
import { getFirstDefined, hasProperty, isEmpty, varName } from '../../util';
import { applyMarkConfig, signalOrValueRef } from '../common';
import { formatCustomType, isCustomFormatType } from '../format';
import * as mixins from '../mark/encode';
import { STORE } from '../selection';
export var legendEncodeRules = {
  symbols: symbols,
  gradient: gradient,
  labels: labels,
  entries: entries
};
export function symbols(symbolsSpec, _ref) {
  var _legendCmpt$get, _legendCmpt$get2, _legendCmpt$get3, _getMaxValue;
  var fieldOrDatumDef = _ref.fieldOrDatumDef,
    model = _ref.model,
    channel = _ref.channel,
    legendCmpt = _ref.legendCmpt,
    legendType = _ref.legendType;
  if (legendType !== 'symbol') {
    return undefined;
  }
  var markDef = model.markDef,
    encoding = model.encoding,
    config = model.config,
    mark = model.mark;
  var filled = markDef.filled && mark !== 'trail';
  var out = _objectSpread(_objectSpread({}, applyMarkConfig({}, model, FILL_STROKE_CONFIG)), mixins.color(model, {
    filled: filled
  })); // FIXME: remove this when VgEncodeEntry is compatible with SymbolEncodeEntry
  var symbolOpacity = (_legendCmpt$get = legendCmpt.get('symbolOpacity')) !== null && _legendCmpt$get !== void 0 ? _legendCmpt$get : config.legend.symbolOpacity;
  var symbolFillColor = (_legendCmpt$get2 = legendCmpt.get('symbolFillColor')) !== null && _legendCmpt$get2 !== void 0 ? _legendCmpt$get2 : config.legend.symbolFillColor;
  var symbolStrokeColor = (_legendCmpt$get3 = legendCmpt.get('symbolStrokeColor')) !== null && _legendCmpt$get3 !== void 0 ? _legendCmpt$get3 : config.legend.symbolStrokeColor;
  var opacity = symbolOpacity === undefined ? (_getMaxValue = getMaxValue(encoding.opacity)) !== null && _getMaxValue !== void 0 ? _getMaxValue : markDef.opacity : undefined;
  if (out.fill) {
    // for fill legend, we don't want any fill in symbol
    if (channel === 'fill' || filled && channel === COLOR) {
      delete out.fill;
    } else if (hasProperty(out.fill, 'field')) {
      // For others, set fill to some opaque value (or nothing if a color is already set)
      if (symbolFillColor) {
        delete out.fill;
      } else {
        var _config$legend$symbol;
        out.fill = signalOrValueRef((_config$legend$symbol = config.legend.symbolBaseFillColor) !== null && _config$legend$symbol !== void 0 ? _config$legend$symbol : 'black');
        out.fillOpacity = signalOrValueRef(opacity !== null && opacity !== void 0 ? opacity : 1);
      }
    } else if (isArray(out.fill)) {
      var _ref2, _getFirstConditionVal, _encoding$fill;
      var fill = (_ref2 = (_getFirstConditionVal = getFirstConditionValue((_encoding$fill = encoding.fill) !== null && _encoding$fill !== void 0 ? _encoding$fill : encoding.color)) !== null && _getFirstConditionVal !== void 0 ? _getFirstConditionVal : markDef.fill) !== null && _ref2 !== void 0 ? _ref2 : filled && markDef.color;
      if (fill) {
        out.fill = signalOrValueRef(fill);
      }
    }
  }
  if (out.stroke) {
    if (channel === 'stroke' || !filled && channel === COLOR) {
      delete out.stroke;
    } else if (hasProperty(out.stroke, 'field') || symbolStrokeColor) {
      // For others, remove stroke field
      delete out.stroke;
    } else if (isArray(out.stroke)) {
      var stroke = getFirstDefined(getFirstConditionValue(encoding.stroke || encoding.color), markDef.stroke, filled ? markDef.color : undefined);
      if (stroke) {
        out.stroke = {
          value: stroke
        };
      }
    }
  }
  if (channel !== OPACITY) {
    var condition = isFieldDef(fieldOrDatumDef) && selectedCondition(model, legendCmpt, fieldOrDatumDef);
    if (condition) {
      out.opacity = [_objectSpread({
        test: condition
      }, signalOrValueRef(opacity !== null && opacity !== void 0 ? opacity : 1)), signalOrValueRef(config.legend.unselectedOpacity)];
    } else if (opacity) {
      out.opacity = signalOrValueRef(opacity);
    }
  }
  out = _objectSpread(_objectSpread({}, out), symbolsSpec);
  return isEmpty(out) ? undefined : out;
}
export function gradient(gradientSpec, _ref3) {
  var _legendCmpt$get4;
  var model = _ref3.model,
    legendType = _ref3.legendType,
    legendCmpt = _ref3.legendCmpt;
  if (legendType !== 'gradient') {
    return undefined;
  }
  var config = model.config,
    markDef = model.markDef,
    encoding = model.encoding;
  var out = {};
  var gradientOpacity = (_legendCmpt$get4 = legendCmpt.get('gradientOpacity')) !== null && _legendCmpt$get4 !== void 0 ? _legendCmpt$get4 : config.legend.gradientOpacity;
  var opacity = gradientOpacity === undefined ? getMaxValue(encoding.opacity) || markDef.opacity : undefined;
  if (opacity) {
    // only apply opacity if it is neither zero or undefined
    out.opacity = signalOrValueRef(opacity);
  }
  out = _objectSpread(_objectSpread({}, out), gradientSpec);
  return isEmpty(out) ? undefined : out;
}
export function labels(specifiedlabelsSpec, _ref4) {
  var fieldOrDatumDef = _ref4.fieldOrDatumDef,
    model = _ref4.model,
    channel = _ref4.channel,
    legendCmpt = _ref4.legendCmpt;
  var legend = model.legend(channel) || {};
  var config = model.config;
  var condition = isFieldDef(fieldOrDatumDef) ? selectedCondition(model, legendCmpt, fieldOrDatumDef) : undefined;
  var opacity = condition ? [{
    test: condition,
    value: 1
  }, {
    value: config.legend.unselectedOpacity
  }] : undefined;
  var format = legend.format,
    formatType = legend.formatType;
  var text = undefined;
  if (isCustomFormatType(formatType)) {
    text = formatCustomType({
      fieldOrDatumDef: fieldOrDatumDef,
      field: 'datum.value',
      format: format,
      formatType: formatType,
      config: config
    });
  } else if (format === undefined && formatType === undefined && config.customFormatTypes) {
    if (fieldOrDatumDef.type === 'quantitative' && config.numberFormatType) {
      text = formatCustomType({
        fieldOrDatumDef: fieldOrDatumDef,
        field: 'datum.value',
        format: config.numberFormat,
        formatType: config.numberFormatType,
        config: config
      });
    } else if (fieldOrDatumDef.type === 'temporal' && config.timeFormatType && isFieldDef(fieldOrDatumDef) && fieldOrDatumDef.timeUnit === undefined) {
      text = formatCustomType({
        fieldOrDatumDef: fieldOrDatumDef,
        field: 'datum.value',
        format: config.timeFormat,
        formatType: config.timeFormatType,
        config: config
      });
    }
  }
  var labelsSpec = _objectSpread(_objectSpread(_objectSpread({}, opacity ? {
    opacity: opacity
  } : {}), text ? {
    text: text
  } : {}), specifiedlabelsSpec);
  return isEmpty(labelsSpec) ? undefined : labelsSpec;
}
export function entries(entriesSpec, _ref5) {
  var legendCmpt = _ref5.legendCmpt;
  var selections = legendCmpt.get('selections');
  return selections !== null && selections !== void 0 && selections.length ? _objectSpread(_objectSpread({}, entriesSpec), {}, {
    fill: {
      value: 'transparent'
    }
  }) : entriesSpec;
}
function getMaxValue(channelDef) {
  return getConditionValue(channelDef, function (v, conditionalDef) {
    return Math.max(v, conditionalDef.value);
  });
}
export function getFirstConditionValue(channelDef) {
  return getConditionValue(channelDef, function (v, conditionalDef) {
    return getFirstDefined(v, conditionalDef.value);
  });
}
function getConditionValue(channelDef, reducer) {
  if (hasConditionalValueDef(channelDef)) {
    return array(channelDef.condition).reduce(reducer, channelDef.value);
  } else if (isValueDef(channelDef)) {
    return channelDef.value;
  }
  return undefined;
}
function selectedCondition(model, legendCmpt, fieldDef) {
  var selections = legendCmpt.get('selections');
  if (!(selections !== null && selections !== void 0 && selections.length)) return undefined;
  var field = stringValue(fieldDef.field);
  return selections.map(function (name) {
    var store = stringValue(varName(name) + STORE);
    return "(!length(data(".concat(store, ")) || (").concat(name, "[").concat(field, "] && indexof(").concat(name, "[").concat(field, "], datum.value) >= 0))");
  }).join(' || ');
}